import {createEntityAdapter} from '@reduxjs/toolkit';

import {type EmployeeGroup} from 'api/employee-groups/employee-groups.types';
import {type EventByCityItem} from 'api/events/events.types';
import {EMPLOYEE_GROUP_STATUS_ORDERED} from 'pages/employee-parking/constants';

/*
 * CRUD adapter for handling Employee Parking Groups data within the store. Default is Keyed by external id but sorted first by status ('active', 'expired', 'disabled'), then alphabetically by title.
 *
 * @see https://redux-toolkit.js.org/api/createEntityAdapter
 */
export const employeeParkingGroupsAdapter = createEntityAdapter<EmployeeGroup>({
    selectId: (group) => group.externalId,
    sortComparer: (a, b) => {
        const statusA = a.groupStatus;
        const statusB = b.groupStatus;
        const order =
            EMPLOYEE_GROUP_STATUS_ORDERED.indexOf(statusA) -
            EMPLOYEE_GROUP_STATUS_ORDERED.indexOf(statusB);

        if (order === 0) {
            return (a.title || '').localeCompare(b.title || '');
        }

        return order;
    },
});

export type EmployeeParkingEvent = EventByCityItem & {
    eventSlot?: EmployeeGroup['eventSlots'][number] | null;
};

/*
 * CRUD adapter for handling Employee Parking Events data within the store. Default is Keyed by event id but sorted by start date then alphabetically by title.
 *
 * @see https://redux-toolkit.js.org/api/createEntityAdapter
 */
export const employeeParkingEventsAdapter =
    createEntityAdapter<EmployeeParkingEvent>({
        selectId: (event) => event.id,
        sortComparer: (a, b) => {
            if (a.starts === b.starts) {
                return (a.title || '').localeCompare(b.title || '');
            }

            return a.starts.localeCompare(b.starts);
        },
    });
